import IconButton from "components/Button/IconButton"
import { Portal } from "components/Portal"
import { MOBILEDEVICEWIDTH } from "config/constants"
import { Content, Horizontal } from "gls"
import { colours } from "styling/colours"
import { media, style } from "typestyle"
import { icons } from 'assets/icons/index'
import { useState } from "react"
import { StretchSpacer } from "gls"
import Button from "components/Button/Button"
import { ImportConfirmationModal } from "./ImportConfirmationModal"
import ImportProgress from "./ImportProgress"
import { useBeaconlistStore, useUnregisteredBeaconStore } from "contexts/RootStore.context"
import { alertErrorMessage, alertSuccessMessage } from "utils/alerts"
import { observer } from "mobx-react"
import { cloneDeep } from "lodash"

type ImportNewBeaconsProps = {
  onClose: () => void;
  selectedBeacons: Set<string>;
}

export const ImportNewBeacons = observer((props: ImportNewBeaconsProps) => {

  const [loading, setLoading] = useState(false)
  const [confirmModal, setComfirmModal] = useState(false)
  const [importIndex, setImportIndex] = useState(0);
  const { beaconList, loadUnregisteredBeacons, setSearchTerm,
    setSelectedBeaconToCreateAsset,
    createBeacon
  } = useUnregisteredBeaconStore()
  const { loadBeacons } = useBeaconlistStore()

  function getSuccessString(beaconCount: number) {
    return beaconCount > 1
      ? `${beaconCount} New Beacons have been imported`
      : '1 New Beacon has been imported';
  }


  const ImportBeacons = async () => {
    const beacons = cloneDeep(beaconList.filter(r => props.selectedBeacons.has(r.beacon_id)))
    const errors = []
    for (const beacon of beacons) {
      try {
        await createBeacon(beacon)
      }
      catch (err) {
        errors.push(err)
        alertErrorMessage('Error importing beacon');
      }
      setImportIndex(importIndex + 1)
    }
    // this line is for displaying the 100%, when some perecntages are skipped due to batched renders
    setImportIndex(props.selectedBeacons.size)

    setTimeout(() => {
      props.onClose()
      setSearchTerm('')
      if (errors.length > 0)
        alertErrorMessage('Error importing beacons');
      else
        alertSuccessMessage(getSuccessString(props.selectedBeacons.size));
      setLoading(false)
      loadUnregisteredBeacons(true)
      loadBeacons(true)
    }, 1000)
  }

  const onImport = (isCreateMode: boolean) => {
    if (isCreateMode) {
      const beacon = beaconList.filter(r => props.selectedBeacons.has(r.beacon_id))
      if (beacon.length > 0) {
        setSelectedBeaconToCreateAsset(beacon[0])
        setComfirmModal(false)
        return
      }
    }
    setComfirmModal(false)
    setLoading(true)
    setTimeout(() => { ImportBeacons() }, 1000)
  }

  return (
    <Portal>
      <Horizontal spacing={5} className={importPanelStyle}>
        <IconButton
          ariaLabel="Close"
          icon={<icons.CloseIcon aria-label='Close' width={12} height={12} fill="white" />}
          onClick={props.onClose}
          disabled={loading}
        />
        <Content
          verticalAlign="center"
          horizontalAlign="center"
          id="selected-tasks-count-div"
          className="number"
        >
          {props.selectedBeacons.size}
        </Content>
        <span>beacons selected</span>
        <StretchSpacer />
        <Button onClick={() => setComfirmModal(true)} id="import-button">Import</Button>
      </Horizontal>

      {confirmModal &&
        <ImportConfirmationModal
          onClose={() => setComfirmModal(false)}
          onImport={onImport}
          selectedCount={props.selectedBeacons.size}
        />
      }
      {loading &&
        <ImportProgress importedCount={importIndex} totalCount={props.selectedBeacons.size} />
      }
    </Portal>
  )
})

const importPanelStyle = style({
  width: '400px',
  position: "fixed",
  bottom: 30,
  left: '40%',
  zIndex: 2,
  backgroundColor: "#222222",
  color: colours.white,
  lineHeight: "50px",
  padding: "10px 10px",
  borderRadius: "5px",
  ...media(
    { maxWidth: MOBILEDEVICEWIDTH },
    { fontSize: "12px !important" }
  ),

  $nest: {
    ".number": {
      marginTop: "10px",
      backgroundColor: "rgba(255, 255, 255, 0.3)",
      width: 33,
      height: 33,
      borderRadius: "100%",
      ...media(
        { maxWidth: MOBILEDEVICEWIDTH },
        {
          width: 20,
          height: 20,
        }
      )
    }
  }
})